export default __webpack_public_path__ + "static/media/construction--flat--flat-driveway.dbed896e.png";